export const LABEL = {
    /***** ROTTE APP MOBILE *****/
    DEAL_DETAIL: 'deal-detail',
    TUTORIAL_DETAIL: 'tutorial-detail',
    COMMUNICATION_DETAIL: 'communication-detail',

    DEAL_LIST: 'deal-list',
    TUTORIAL_LIST: 'tutorial-list',
    COMMUNICATION_LIST: 'communication-list',

    NUOVE_OFFERTE: 'nuove-offerte',

    SAVED_LIST: 'saved-list',
    FAVORITES_LIST: 'favorites-list',
    LIKED_LIST: 'liked-list',

    CONST_DEAL: 'deal',
    CONST_COMMUNICATION: 'communication',
    CONST_TUTORIAL: 'tutorial',

    CONST_INITIAL_SENTENCE_PROMOZIONE: 'promozione'
};


export const FIREBASE_AUTH_MESSAGES: Record<string, string> = {
    'auth/wrong-password': 'La password non è corretta. Verifica e riprova.',
    'auth/user-not-found': 'Nessun account trovato con questa e-mail.',
    'auth/invalid-email': 'L’indirizzo e-mail non è valido.',
    'auth/too-many-requests': 'Hai effettuato troppe richieste. Attendi qualche minuto e riprova.',
    'auth/email-already-in-use': 'Esiste già un account con questa e-mail.',
    'auth/weak-password': 'La password è troppo debole. Utilizza almeno 6 caratteri con lettere e numeri.',
    'auth/network-request-failed': 'Problema di rete. Controlla la connessione e riprova.',
    'auth/user-disabled': 'Questo account è stato disabilitato.',
    'auth/operation-not-allowed': 'Operazione non consentita. Contatta l’assistenza.',
    'auth/popup-closed-by-user': 'Operazione annullata.',
    'auth/cancelled-popup-request': 'Richiesta annullata.',
    'auth/account-exists-with-different-credential': 'Esiste già un account con questa e-mail tramite un altro provider.',
    'auth/invalid-credential': 'Credenziali non valide. Riprova.',
    'auth/requires-recent-login': 'Per questa operazione devi autenticarti di nuovo.'
};

export const HTTP_STATUS_MESSAGES: Record<number, string> = {
    0:   'Impossibile contattare il server. Controlla la connessione e riprova.',
    400: 'Richiesta non valida. Controlla i dati inseriti.',
    401: 'Sessione scaduta o non autorizzata. Effettua di nuovo l’accesso.',
    403: 'Non hai i permessi per eseguire questa azione.',
    404: 'Risorsa non trovata.',
    409: 'Conflitto di dati. Aggiorna riavvia l\'app e riprova.',
    422: 'Dati non validi. Controlla i campi e riprova.',
    500: 'Errore interno del server. Rivvia l\'app o riprova più tardi.'
};
